export const column2object = (columns: any[]) => {
  return {
    disabled: !!columns[2],
    key: columns[3] || '',
    textContent: columns[4] || '',
    image: columns[5] || '',
    order: columns[6] || 1,
  };
};
